import React, { useEffect } from 'react';
import { Box, FlexControlledForm,useDebounceState } from '@common-fe/common-fe';

import { PersonalInformationPayload,useStore } from '../stores/usePersonalInformation.store';

import { useAnnualIncomeFields } from './hooks';

interface Props {
  onDirty?: (isDirty: boolean) => void;
}

const AnnualIncome: React.FC<Props> = ({ onDirty }) => {
  const fields = useAnnualIncomeFields();
  const handleSetState = useStore((state) => state.setState);
  const showErrors = useStore((state) => state.showErrors);

  const { setValues, values } = useDebounceState<Partial<PersonalInformationPayload>>();

  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);
  return (
    <Box background="canvas" round="container1Round" margin={{ bottom: 'spacing24' }} data-testid="AnnualIncome-wrapper">
      <FlexControlledForm
        fields={fields}
        shouldControlValues
        testId="annual_income_form"
        showError={showErrors}
        editMode
        onChangeValues={setValues}
        onDirty={onDirty}
      />
    </Box>
  );
};
export default AnnualIncome;
